module.exports = __webpack_public_path__ + "img/photos/slider-04a.jpg";